import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { gpsSinglePointTranslations } from '../translations/gpsSinglePoint';
import { IonAlert, useIonViewWillEnter } from '@ionic/react';
import { Geolocation } from '@capacitor/geolocation';
import React, { useState } from 'react';

interface UserCoordinates
{
    setUserCoords: any
}

/**
This component is only used to get user GPS coordinates and requires a setter method to
a "any" state-object created on the parent class, which will be called once the coordinates
get retrieved.
[see Docks.tsx as example]
*/
const GpsSinglePointComponent: React.FC<UserCoordinates> = ({setUserCoords}) => {
  const { language } = useContext(LanguageContext);
  const t = gpsSinglePointTranslations[language];

  const [coords, setCoords] = useState<any|null>(null)
  const [showAlert, setShowAlert] = useState(false);

  const getCurrentPosition = async () =>
  {
    await Geolocation.getCurrentPosition({enableHighAccuracy: true})
      .then(coordinates => {
        setUserCoords(coordinates.coords);
      })
      .catch( error =>
      {
        console.log('getCurrentPosition:: ERROR ', error);
        setShowAlert(true);
      });
  };

  // try to get fresh GPS coordinates everytime the user opens this view
  useIonViewWillEnter(() => {
    getCurrentPosition();
  });

  return (
    <IonAlert
      header={t.errorHeader}
      isOpen={showAlert}
      message={t.errorMessage}
      buttons={[{ text: t.okButton }]}
      onDidDismiss={() => setShowAlert(false)}
    />
  );
};

export default GpsSinglePointComponent;
